import { FormattedMessage } from 'react-intl';
import { Handle, Position } from 'reactflow';

import { AutomationBlockOutputEnum, AutomationFragment as AutomationType } from '@typing/Generated';

type Block = NonNullable<AutomationType['blocks'][number]>;

type Props = {
  data: {
    onSelect: (node: Node) => void;
    parent: Block;
    parentOutput: AutomationBlockOutputEnum;
  };
};

const AutomationTerminatorBlockNode = ({}: Props) => (
  <div>
    <Handle id="input" isConnectable={false} position={Position.Top} type="target" />
    <div>
      <FormattedMessage id="models.automation.blockTypes.terminator" />
    </div>
  </div>
);

export default AutomationTerminatorBlockNode;
